// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 161) return "dist/js/app.min/react-app.js";
	if (chunkId === 842) return "dist/js/app.min/map.js";
	if (chunkId === 121) return "dist/js/app.min/gallery.js";
	// return url for filenames based on template
	return undefined;
};